import React from "react";
import SEO from '../Component/SEO';
import './About.css';
import AboutCard from './AboutCard';
import AboutNewRead from './AboutNewRead';
import Gfooter from "../Component/Gfooter";
import WhyChooseNew from "./WhyChooseNew";
import Client from "../Component/Client";
import Recognised from "../career/Recognised";
import ClientSpeackData from "../Component/ClientSpeackData";
import Testimonials1 from "../Component/Testimonials1";

function About() {
  return (
    <div className="about-top1">

      <SEO
        title="About NLF Solutions | Architectural Solutions Company in India"
        description="Learn about NLF Solutions, an architectural solutions company providing metal ceilings, facades, roofing, furniture and acoustic solutions across India."
        canonical="https://nlfs.in/about-us"
        keywords="Architectural Solutions Company, NLF Solutions, Architectural products company, Architectural solutions provider, Interior solutions company, Architectural product supplier, leading architectural solutions company in India, architectural products company in Nagpur, trusted architectural solutions provider"
      />
      <h1 className="seo-h1">About NLF Solutions</h1>
      <AboutNewRead />
      <AboutCard />
      <WhyChooseNew />
      <Client />
      {/* <Recognised/> */}
      {/* <Testimonials1/> */}
      <Gfooter />
    </div>
  );
}

export default About;
